/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

import type { OrganizationTheme } from "../../types";

export const forestCreamTheme: OrganizationTheme = {
  id: "forest-cream",
  name: "Forest Cream",
  description:
    "Earthy, natural palette with deep greens and warm cream accents",
  recommendedFor: [
    "Landscaping",
    "Outdoor Construction",
    "Environmental Services",
    "Sustainable Building",
  ],

  colors: {
    primary: {
      name: "Evergreen",
      hex: "#606C38",
      hsl: "78 30% 32%",
      rgb: [96, 108, 56],
    },
    primaryForeground: {
      name: "White",
      hex: "#FFFFFF",
      hsl: "0 0% 100%",
      rgb: [255, 255, 255],
    },
    secondary: {
      name: "Bronze",
      hex: "#DDA15E",
      hsl: "30 64% 62%",
      rgb: [221, 161, 94],
    },
    secondaryForeground: {
      name: "Black Forest",
      hex: "#283618",
      hsl: "88 44% 15%",
      rgb: [40, 54, 24],
    },
    muted: {
      name: "Light Gray",
      hex: "#F5F5F5",
      hsl: "0 0% 96%",
      rgb: [245, 245, 245],
    },
    mutedForeground: {
      name: "Medium Gray",
      hex: "#666666",
      hsl: "0 0% 40%",
      rgb: [102, 102, 102],
    },
    card: {
      name: "White",
      hex: "#FFFFFF",
      hsl: "0 0% 100%",
      rgb: [255, 255, 255],
    },
    cardForeground: {
      name: "Near Black",
      hex: "#1F1F1F",
      hsl: "0 0% 12%",
      rgb: [31, 31, 31],
    },
    background: {
      name: "White",
      hex: "#FFFFFF",
      hsl: "0 0% 100%",
      rgb: [255, 255, 255],
    },
    foreground: {
      name: "Near Black",
      hex: "#1F1F1F",
      hsl: "0 0% 12%",
      rgb: [31, 31, 31],
    },
  },

  cssVariables: {
    "--primary": "78 30% 32%",
    "--primary-foreground": "0 0% 100%",
    "--secondary": "30 64% 62%",
    "--secondary-foreground": "88 44% 15%",
    "--muted": "0 0% 96%",
    "--muted-foreground": "0 0% 40%",
    "--card": "0 0% 100%",
    "--card-foreground": "0 0% 12%",
    "--background": "0 0% 100%",
    "--foreground": "0 0% 12%",
    // Semantic colors — warm-shifted to harmonize with evergreen/bronze
    "--success": "152 55% 40%",
    "--success-foreground": "0 0% 98%",
    "--warning": "32 80% 48%",
    "--warning-foreground": "0 0% 12%",
    "--error": "4 72% 46%",
    "--error-foreground": "0 0% 98%",
    "--info": "210 60% 48%",
    "--info-foreground": "0 0% 98%",
    "--destructive": "4 72% 46%",
    "--destructive-foreground": "0 0% 98%",
    // Sidebar / warm surface — subtle tint of secondary hue
    "--background-warm": "30 20% 98%",
    "--background-warm-alt": "30 15% 96%",
    // Extended palette — earthy warmth with natural accent hues
    "--palette-violet": "270 40% 48%",
    "--palette-teal": "168 45% 38%",
    "--palette-pink": "345 50% 50%",
    "--palette-orange": "18 75% 50%",
    "--palette-sky": "195 60% 44%",
  },
};
